// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DO9_","colBig":"styles_colBig__j46MR","colSmall":"styles_colSmall__2p_uN","shopifyNameWrapper":"styles_shopifyNameWrapper__2LJDw"};